/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useWindowSize } from 'react-use';

import { ConfigContext } from 'store/context';

import { TAB_SIZE } from '../../constants/ThemeSetting';

function SidebarLogo() {
  const { width } = useWindowSize();
  const {
    ConfigState: { statusCollapse: status },
  } = useContext(ConfigContext);

  const classes = classNames({
    'omi-menu-logo': true,
    '-ml-2': status,
  });

  return (
    <div className={classes}>
      <Link to="/" className="omi-site-logo">
        {width < TAB_SIZE ? (
          <img alt="" src={require('assets/svg/Logo.svg').default} />
        ) : status ? (
          <img alt="" className="logo-icon" src={require('assets/svg/logo-icon.svg').default} />
        ) : (
          <img alt="" src={require('assets/svg/Logo.svg').default} />
        )}
      </Link>
    </div>
  );
}

export default SidebarLogo;
